import { db } from "../services/db";
export interface ModelProps {
    _id:any,
    _rev:any,
    _attachments:any;
    type:string,
    created_at:string,
    modified_at:string,        
}

export interface StateProps<dataProps> {
    row: dataProps,
    rows: dataProps[],
    loading: boolean,
    loadingRows: boolean,
    msg: string;
    error: boolean
    showAlert: boolean,
    status: string,
    showDialogExluir: boolean
    showCadModal:boolean,
    showSelectModal:boolean,
    changeList:string,//data hora que dos dados foi alterado na lista
}


export class Model<dataProps extends ModelProps, stateProps extends StateProps<dataProps>> {
    public props:dataProps
    public state:stateProps
    protected initialState:stateProps
    public moduloName:string;
    public db = db;
    constructor(moduloName:string){
        this.moduloName = moduloName;
        this.props = {
            _id:undefined,
            _rev:undefined,
            created_at:"",
            modified_at:"",
            type:moduloName,
        } as dataProps
        this.initialState = {
            row: this.props,
            rows: [],
            loading: false,
            loadingRows: false,
            error: false,
            msg: "",
            status: "",
            showAlert: false,
            showDialogExluir: false,
            showCadModal: false,
            showSelectModal:false,
            changeList:"",
        } as unknown as stateProps
        this.state = this.initialState;
    }

    setProps(row:dataProps){
        this.props = row;
    }
    setState(state:stateProps){
        return this.state = state;
    }

    setInitialValueState(stateInitial:stateProps){
        return this.initialState = stateInitial;
    }

    getInititalValueState(){
        return this.initialState  
    }

    getInitialValue(){
        return this.props;
    }
}